<template>
  <BaseButton
    text
    color="white"
    retain-focus-on-click
    :ripple="false"
    :disabled="isDisabled"
    @click="openDictionaryPopup()"
  >
    <BaseSpriteIcon icon-name="ico-translate"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{
      $t('Context.short.translate')
    }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

import PopupNamesEnum from '@/enums/PopupNamesEnum';
import DictionaryPopupTabIds from '@/enums/DictionaryPopupTabIds';

export default {
  name: 'TranslateControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  computed: {
    bookId() {
      const openParams = this.$store.getters[
        'OpenParameterStore/getPublicationOpenParameters'
      ];
      return openParams?.publicationId;
    },
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    readingSettingsView() {
      return this.$store.getters['ReadingSettingsStore/getReadingSettingsView'];
    },
    isDisabled() {
      return this.$attrs.hasOwnProperty('disabled')
        ? this.$attrs.disabled
        : false;
    }
  },
  methods: {
    openDictionaryPopup() {
      this.$store.dispatch('ManagePopupStore/openPopup', {
        name: PopupNamesEnum.DICTIONARY_POPUP,
        popupContext: {
          activeTabId: DictionaryPopupTabIds.TRANSLATOR
        }
      });
    }
  }
};
</script>
